import React, { useState, useCallback } from 'react';
import { useQuery } from '@apollo/client';

import { Translator } from 'ggApp/modules/translator/components';
import { EnergyLabelQueryQuery, EnergyRating } from 'ggApp/types/graphql';

import EnergySheetModal from './modal/EnergySheetModal';
import { Container, TextWrap, ToolTipText, EnergyClass } from './styles';
import { energyRatingIcon } from './utils/energyLabelsMapper';
import EnergyLabelQuery from './EnergyLabelQuery.graphql';

interface EnergyLabelProps {
    className: string;
    energyRating: EnergyRating;
    productId: string;
    activeLanguage: string | undefined;
}

export const EnergyLabel = ({
    className,
    energyRating,
    productId,
    activeLanguage,
}: EnergyLabelProps) => {
    const [modal, setModal] = useState(null);
    const [isOpen, setIsOpen] = useState(false);

    const createModalRef = useCallback((newModal) => {
        setModal(newModal);
    }, []);

    const showModal = useCallback(() => {
        if (modal) {
            modal.openModal();
        }
    }, [modal]);

    const { data, loading } = useQuery<EnergyLabelQueryQuery>(EnergyLabelQuery, {
        variables: { productId },
        skip: !isOpen,
    });

    const { imageUrl, energySpecs } = data?.product?.energyLabel ?? {};
    const pdfLinkUrl = energySpecs?.[activeLanguage || 'en'] ?? '';

    return (
        <>
            <Container className={className} data-testid="energy-label-container">
                <EnergyClass icon={energyRatingIcon[energyRating]} width={44} height={24} />
                <TextWrap>
                    <ToolTipText
                        data-testid="energy-label-product-sheet"
                        onClick={() => showModal()}
                    >
                        <span>
                            <Translator tk="ENERGY_LABEL_PRODUCT_SHEET" />
                        </span>
                    </ToolTipText>
                </TextWrap>
            </Container>
            <EnergySheetModal
                modalRef={createModalRef}
                onOpen={() => setIsOpen(true)}
                loading={loading}
                imageUrl={imageUrl}
                pdfLinkUrl={pdfLinkUrl}
            />
        </>
    );
};
